module.exports = __webpack_public_path__ + "static/media/guides.43403b73.png";